module.exports = __webpack_public_path__ + "static/media/annotationInactive.8a4ccac9.png";